import script from "./MesReservations.vue?vue&type=script&setup=true&lang=js"
export * from "./MesReservations.vue?vue&type=script&setup=true&lang=js"

import "./MesReservations.vue?vue&type=style&index=0&id=b48f0ae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b48f0ae6"]])

export default __exports__